const normalizeValue = (value) => (value === undefined || value === null ? '' : value);

/**
 * Maps form values (plan, member_id, etc.) to Wrapper format (plan_id, external_member_id, etc.)
 */
export const mapFormValuesToWrapperFormat = (values = {}) => ({
  plan_type: normalizeValue(values.plan_type),
  plan_id: normalizeValue(values.plan),
  external_member_id: normalizeValue(values.member_id),
  external_group_id: normalizeValue(values.group_id),
  enrolled_at_converted: normalizeValue(values.enrollment),
  expired_at_converted: normalizeValue(values.expiration),
});

/**
 * Syncs Wrapper form values back to parent form (fieldPrefix.plan, etc.)
 */
export const syncWrapperValuesToParentForm = (fieldPrefix, parentForm, values) => {
  if (!values || !parentForm) return;

  const updates = [
    { formField: 'plan_type', value: values.plan_type },
    { formField: 'plan', value: values.plan_id },
    { formField: 'member_id', value: values.external_member_id },
    { formField: 'group_id', value: values.external_group_id },
    { formField: 'enrollment', value: values.enrolled_at_converted },
    { formField: 'expiration', value: values.expired_at_converted },
  ];

  updates.forEach(({ formField, value }) => {
    parentForm.change(`${fieldPrefix}.${formField}`, value);
  });
};
